export enum Currencies {
  EUR = 'EUR',
  USD = 'USD',
}
